import { Routes, Route } from "react-router-dom";
import Pages from "./pages";

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<Pages.Login />} />
      <Route path="/forgot-password" element={<Pages.ForgotPassword />} />
      <Route path="/otp" element={<Pages.OtpVerification />} />
      <Route path="/reset-password" element={<Pages.ResetPassword />} />
      <Route path="/dashboard" element={<Pages.Dashboard />} />
      <Route path="/manage-customers" element={<Pages.ManageCustomers />} />
      <Route
        path="/manage-customers/detail/:id"
        element={<Pages.ManageCustomerDetail />}
      />
      <Route path="/manage-customers/add" element={<Pages.AddUser />} />
      <Route path="/manage-customers/edit/:id" element={<Pages.AddUser />} />

      <Route path="/manage-categories" element={<Pages.ManageCategories />} />
      <Route path="/manage-payments" element={<Pages.ManagePayments />} />
      <Route path="/manage-subadmin" element={<Pages.ManageSubadmin />} />
      <Route path="/manage-subadmin/add" element={<Pages.AddSubadmin />} />
      <Route path="/manage-subadmin/edit/:id" element={<Pages.AddSubadmin />} />
      <Route
        path="/manage-subadmin/detail/:id"
        element={<Pages.SubadminDetail />}
      />
      <Route
        path="/manage-subadmin/roles"
        element={<Pages.ManageSubadminRoles />}
      />
      <Route path="/manage-subadmin/roles/add" element={<Pages.AddRole />} />
      <Route
        path="/manage-subadmin/roles/edit/:id"
        element={<Pages.AddRole />}
      />
      <Route
        path="/manage-subadmin/roles/detail/:id"
        element={<Pages.RoleDetail />}
      />
      <Route path="/revenue-analytics" element={<Pages.ManageAnalytics />} />

      <Route
        path="/manage-notifications"
        element={<Pages.ManageNotifications />}
      />
      <Route
        path="/recieved-notifications"
        element={<Pages.RecievedNotifications />}
      />
      <Route path="/manage-reviews" element={<Pages.ManageReviews />} />
      <Route path="/manage-cms" element={<Pages.ManageCms />} />
      <Route path="/manage-profile" element={<Pages.ManageProfile />} />
      <Route path="/manage-profile/edit" element={<Pages.EditProfile />} />
      <Route
        path="/manage-profile/change-password"
        element={<Pages.ChangePassword />}
      />
      <Route path="/manage-offer" element={<Pages.OfferManagement />} />
      <Route path="/manage-offer/build-offer/" element={<Pages.BuildOffer />} />

      <Route
        path="/manage-offer/build-offer/edit/:id"
        element={<Pages.BuildOffer />}
      />
      <Route
        path="/manage-offer/preview-offer"
        element={<Pages.PreviewOffer />}
      />
      <Route
        path="/manage-offer/preview-offer-detail/:id"
        element={<Pages.PreviewOfferDetail />}
      />
      <Route path="/manage-employee" element={<Pages.ManageEmployee />} />
      <Route path="/manage-employee/add" element={<Pages.AddEmployee />} />
      <Route path="/manage-employee/edit/:id" element={<Pages.AddEmployee />} />
      <Route
        path="/manage-employee/view/:id"
        element={<Pages.ViewEmployee />}
      />
      <Route path="/manage-booking-resvp" element={<Pages.RsvpTracker />} />
      <Route
        path="/manage-butterfly-effect"
        element={<Pages.ManageButterflyEffect />}
      />
      <Route
        path="/manage-booking-resvp/booking-detail/:id"
        element={<Pages.RsvpBookingDetail />}
      />
      <Route
        path="/manage-booking-resvp/booking-detail-view"
        element={<Pages.BookingDetailView />}
      />
      <Route path="/manage-cancellation" element={<Pages.Cancellation />} />
      <Route path="/manage-booking" element={<Pages.Booking />} />
      <Route path="/user-table" element={<Pages.Userlist />} />
      <Route path="/transactions" element={<Pages.ManageTransactions />} />
      <Route path="/manage-groups" element={<Pages.ManageGroups />} />
      <Route path="/manage-groups/tags/:id" element={<Pages.ManageTags />} />
      <Route
        path="/manage-subscription"
        element={<Pages.ManageSubscription />}
      />
      <Route
        path="/manage-subscription/add"
        element={<Pages.AddSubscription />}
      />
      <Route
        path="/manage-subscription/edit/:id"
        element={<Pages.AddSubscription />}
      />
      <Route
        path="/manage-subscription/view"
        element={<Pages.ViewSubscription />}
      />
      <Route path="/manage-cms/viewGroup/:id" element={<Pages.ViewGroup />} />
      <Route path="/manage-coupon" element={<Pages.CoupanManagement />} />
      <Route
        path="/manage-offer/preview-offer-detail/add-user"
        element={<Pages.AddUserLink />}
      />
      <Route
        path="/manage-booking-resvp/edit-history"
        element={<Pages.EditHistory />}
      />
      <Route
        path="/manage-cms/viewGroup/add-members/:id"
        element={<Pages.AddMember />}
      />
      <Route path="/groups" element={<Pages.Groups />} />
      <Route
        path="/manage-booking-resvp/add-exceptional-guest"
        element={<Pages.AddExceptionalGuest />}
      />
      <Route
        path="/manage-booking-resvp/add-user-booking"
        element={<Pages.AddUserBooking />}
      />
      <Route
        path="/manage-notifications/view-users/:id"
        element={<Pages.ViewUsers />}
      />
    </Routes>
  );
};

export default Routing;
